var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1416_16405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6672 7.3342V8.00086C14.6605 9.34641 14.2467 10.6584 13.4804 11.7644C12.714 12.8704 11.6309 13.7186 10.3735 14.1976C9.11603 14.6765 7.74309 14.7637 6.43515 14.4477C5.12721 14.1317 3.9455 13.4274 3.04536 12.4272C2.14523 11.4271 1.56881 10.1779 1.39187 8.84406C1.21494 7.51018 1.44579 6.15398 2.05406 4.95375C2.66233 3.75352 3.61955 2.76545 4.79988 2.11942C5.98022 1.47339 7.32842 1.19966 8.66724 1.3342",
    stroke: "#616E85",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 9.33398C5.33398 9.33398 6.33398 10.6673 8.00065 10.6673C9.66732 10.6673 10.6673 9.33398 10.6673 9.33398",
    stroke: "#616E85",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6H6.00667",
    stroke: "#616E85",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6H10.0067",
    stroke: "#616E85",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.666 3.33398H14.666",
    stroke: "#616E85",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.666 1.33398V5.33398",
    stroke: "#616E85",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1416_16405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddEmoji);
export default __webpack_public_path__ + "static/media/AddEmoji.0f9dc54130be1ca061b9322efeabb73d.svg";
export { ForwardRef as ReactComponent };